/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Event } from '../model/event';
import { EventCreateInput } from '../model/eventCreateInput';
import { EventList } from '../model/eventList';
import { EventUpdateInput } from '../model/eventUpdateInput';
import { Model29 } from '../model/model29';
import { Model89 } from '../model/model89';
import { Model90 } from '../model/model90';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EventService {

    protected basePath = 'http://localhost:5001';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Delete a Event
     * 
     * @param orgName 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOrgsOrgnameEventId(orgName: string, id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteOrgsOrgnameEventId(orgName: string, id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteOrgsOrgnameEventId(orgName: string, id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteOrgsOrgnameEventId(orgName: string, id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling deleteOrgsOrgnameEventId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteOrgsOrgnameEventId.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all Event(s)
     * 
     * @param orgName 
     * @param populate 
     * @param archived 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param offset 
     * @param page 
     * @param limit 
     * @param sortBy 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEvent(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<EventList>;
    public getOrgsOrgnameEvent(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventList>>;
    public getOrgsOrgnameEvent(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventList>>;
    public getOrgsOrgnameEvent(orgName: string, populate?: boolean, archived?: boolean, inlineBlob?: boolean, filter?: string, where?: string, offset?: number, page?: number, limit?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEvent.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (archived !== undefined && archived !== null) {
            queryParameters = queryParameters.set('archived', <any>archived);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }
        if (offset !== undefined && offset !== null) {
            queryParameters = queryParameters.set('offset', <any>offset);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<EventList>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get the count of all Event(s)
     * 
     * @param orgName 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventCount(orgName: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Model29>;
    public getOrgsOrgnameEventCount(orgName: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model29>>;
    public getOrgsOrgnameEventCount(orgName: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model29>>;
    public getOrgsOrgnameEventCount(orgName: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventCount.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Model29>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/count`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Event
     * 
     * @param orgName 
     * @param id 
     * @param populate 
     * @param inlineBlob 
     * @param filter 
     * @param where 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'body', reportProgress?: boolean): Observable<Event>;
    public getOrgsOrgnameEventId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Event>>;
    public getOrgsOrgnameEventId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Event>>;
    public getOrgsOrgnameEventId(orgName: string, id: string, populate?: boolean, inlineBlob?: boolean, filter?: string, where?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameEventId.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (inlineBlob !== undefined && inlineBlob !== null) {
            queryParameters = queryParameters.set('inlineBlob', <any>inlineBlob);
        }
        if (filter !== undefined && filter !== null) {
            queryParameters = queryParameters.set('filter', <any>filter);
        }
        if (where !== undefined && where !== null) {
            queryParameters = queryParameters.set('where', <any>where);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Event>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/${encodeURIComponent(String(id))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Event field
     * 
     * @param orgName 
     * @param id 
     * @param fieldName 
     * @param populate 
     * @param q 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOrgsOrgnameEventIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public getOrgsOrgnameEventIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public getOrgsOrgnameEventIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public getOrgsOrgnameEventIdFieldname(orgName: string, id: string, fieldName: string, populate?: boolean, q?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling getOrgsOrgnameEventIdFieldname.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getOrgsOrgnameEventIdFieldname.');
        }

        if (fieldName === null || fieldName === undefined) {
            throw new Error('Required parameter fieldName was null or undefined when calling getOrgsOrgnameEventIdFieldname.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (populate !== undefined && populate !== null) {
            queryParameters = queryParameters.set('populate', <any>populate);
        }
        if (q !== undefined && q !== null) {
            queryParameters = queryParameters.set('q', <any>q);
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<string>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/${encodeURIComponent(String(id))}/${encodeURIComponent(String(fieldName))}`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a Event
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameEvent(orgName: string, body?: EventCreateInput, observe?: 'body', reportProgress?: boolean): Observable<Event>;
    public postOrgsOrgnameEvent(orgName: string, body?: EventCreateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Event>>;
    public postOrgsOrgnameEvent(orgName: string, body?: EventCreateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Event>>;
    public postOrgsOrgnameEvent(orgName: string, body?: EventCreateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameEvent.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Event>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Import multiple Event
     * 
     * @param orgName 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postOrgsOrgnameEventImport(orgName: string, body?: Model89, observe?: 'body', reportProgress?: boolean): Observable<Model90>;
    public postOrgsOrgnameEventImport(orgName: string, body?: Model89, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Model90>>;
    public postOrgsOrgnameEventImport(orgName: string, body?: Model89, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Model90>>;
    public postOrgsOrgnameEventImport(orgName: string, body?: Model89, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling postOrgsOrgnameEventImport.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Model90>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/import`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a Event
     * 
     * @param orgName 
     * @param id 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameEventId(orgName: string, id: string, body?: EventUpdateInput, observe?: 'body', reportProgress?: boolean): Observable<Event>;
    public putOrgsOrgnameEventId(orgName: string, id: string, body?: EventUpdateInput, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Event>>;
    public putOrgsOrgnameEventId(orgName: string, id: string, body?: EventUpdateInput, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Event>>;
    public putOrgsOrgnameEventId(orgName: string, id: string, body?: EventUpdateInput, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameEventId.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameEventId.');
        }


        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Event>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/${encodeURIComponent(String(id))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Publish a Event
     * 
     * @param orgName 
     * @param id 
     * @param published 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public putOrgsOrgnameEventIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'body', reportProgress?: boolean): Observable<Event>;
    public putOrgsOrgnameEventIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Event>>;
    public putOrgsOrgnameEventIdPublishedPublished(orgName: string, id: string, published: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Event>>;
    public putOrgsOrgnameEventIdPublishedPublished(orgName: string, id: string, published: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (orgName === null || orgName === undefined) {
            throw new Error('Required parameter orgName was null or undefined when calling putOrgsOrgnameEventIdPublishedPublished.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling putOrgsOrgnameEventIdPublishedPublished.');
        }

        if (published === null || published === undefined) {
            throw new Error('Required parameter published was null or undefined when calling putOrgsOrgnameEventIdPublishedPublished.');
        }

        let headers = this.defaultHeaders;

        // authentication (jwt) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.put<Event>(`${this.basePath}/orgs/${encodeURIComponent(String(orgName))}/Event/${encodeURIComponent(String(id))}/published/${encodeURIComponent(String(published))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
